import React from "react";

import { DebugInfoItem } from "./DebugInfoItem";
import { UserFields } from "../../../../../lib/context/Auth/AuthContext";
import { CopyToClipboardButton } from "../../../../shared/CopyToClipboardButton/CopyToClipboardButton";

import "./DebugInfo.scss";

interface Props {
  user: UserFields | undefined;
}

export const DebugInfo = ({ user }: Props) => {
  const debugItems = [
    { title: "customerID", value: user?.customerid },
    { title: "accountID", value: user?.claims?.user_id },
    { title: "email", value: user?.email },
    { title: "subscriptionID", value: user?.claims?.subscriptionId },
  ];

  let clipBoardText = `
  customerID: ${user?.customerid}
  accountID: ${user?.claims?.user_id}
  email: ${user?.email}
  subscriptionID: ${user?.claims?.subscriptionId}
  `;

  return (
    <div className="DebugInfo">
      <h4>For Goget support:</h4>
      <ul>
        {debugItems.map((item) => {
          return (
            <DebugInfoItem
              title={item.title}
              value={item.value}
              key={item.title}
            />
          );
        })}
      </ul>
      <div className="center">
        <CopyToClipboardButton text={clipBoardText} />
      </div>
    </div>
  );
};
